import { Component, Input } from '@angular/core';
import { WindowRefService } from '../../services/window-ref.service';

@Component({
  selector: 'app-title',
  templateUrl: './title.component.html',
  styleUrl: './title.component.scss'
})
export class TitleComponent {

  @Input() title: string = '';
  @Input() showBackButton = true;

  constructor(private windowService: WindowRefService){
  }
  goBack(){
    this.windowService.nativeWindow.history.back();
  }
}
